(function () {
  const normalize = (value) => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();

  class FormulaSwissHelpTopics {
    constructor(root) {
      this.root = root;
      this.searchWrap = root.querySelector('[data-fs-faq-search-wrap]');
      this.form = root.querySelector('[data-fs-faq-search-form]');
      this.search = root.querySelector('[data-fs-faq-search]');
      this.clear = root.querySelector('[data-fs-faq-clear]');
      this.status = root.querySelector('[data-fs-faq-status]');
      this.noResults = root.querySelector('[data-fs-faq-no-results]');
      this.items = Array.from(root.querySelectorAll('[data-fs-faq-item]'));
      this.groups = Array.from(root.querySelectorAll('[data-fs-faq-group]'));
      this.previousOpenState = null;
    }

    init() {
      if (!this.search || !this.searchWrap || !this.status) return;
      this.searchWrap.hidden = false;
      this.search.addEventListener('input', () => this.applyFilter(this.search.value));
      this.clear?.addEventListener('click', () => { this.search.value = ''; this.applyFilter(''); this.search.focus(); });
      this.form?.addEventListener('submit', (event) => event.preventDefault());
      this.root.addEventListener('click', (event) => {
        const anchor = event.target.closest('a[href^="#"]');
        const copy = event.target.closest('[data-fs-faq-copy]');
        if (copy && this.root.contains(copy)) { event.preventDefault(); this.copyLink(copy); return; }
        if (anchor && this.root.contains(anchor)) {
          let id;
          try { id = decodeURIComponent(anchor.getAttribute('href').slice(1)); } catch (error) { return; }
          if (this.revealHash(id)) {
            event.preventDefault();
            if (window.location.hash.slice(1) !== id) window.history.pushState({}, '', `#${id}`);
          }
        }
      });
      window.addEventListener('hashchange', () => this.revealHash(window.location.hash.slice(1)));
      this.items.forEach((item) => this.prepareCopy(item));
      this.updateStatus(this.items.length);
      if (window.location.hash) this.revealHash(window.location.hash.slice(1));
    }

    searchableText(item) {
      const summary = item.querySelector('summary')?.textContent || '';
      const answerNodes = Array.from(item.querySelectorAll('[data-fs-faq-answer] p, .fs-help-answer > p')).filter((node) => !node.closest('.fs-help-handoff'));
      item.querySelectorAll('[data-fs-faq-answer]').forEach((answer) => {
        if (answer.matches('p') && !answerNodes.includes(answer) && !answer.closest('.fs-help-handoff')) answerNodes.push(answer);
      });
      if (!answerNodes.length) {
        const firstParagraph = Array.from(item.querySelectorAll('.fs-help-answer p')).find((node) => !node.closest('.fs-help-handoff'));
        if (firstParagraph) answerNodes.push(firstParagraph);
      }
      const answer = answerNodes.map((p) => p.textContent).join(' ');
      return normalize(`${summary} ${answer} ${item.getAttribute('data-fs-faq-keywords') || ''}`);
    }

    applyFilter(value) {
      const tokens = normalize(value.trim()).split(/\s+/).filter(Boolean);
      if (!tokens.length) {
        this.restoreOpenState();
        this.items.forEach((item) => { item.hidden = false; });
        this.groups.forEach((group) => { group.hidden = false; });
        if (this.noResults) this.noResults.hidden = true;
        if (this.clear) this.clear.hidden = true;
        this.updateStatus(this.items.length);
        return;
      }
      if (!this.previousOpenState) this.previousOpenState = new Map(this.items.map((item) => [item, item.open]));
      let matchCount = 0;
      this.items.forEach((item) => {
        const matches = tokens.every((token) => this.searchableText(item).includes(token));
        item.hidden = !matches;
        if (matches) { matchCount += 1; item.open = true; }
      });
      this.groups.forEach((group) => { group.hidden = !group.querySelector('[data-fs-faq-item]:not([hidden])'); });
      if (this.noResults) this.noResults.hidden = matchCount !== 0;
      if (this.clear) this.clear.hidden = false;
      this.updateStatus(matchCount);
    }

    restoreOpenState() {
      if (!this.previousOpenState) return;
      this.previousOpenState.forEach((isOpen, item) => { item.open = isOpen; });
      this.previousOpenState = null;
    }

    revealHash(id) {
      if (!id) return false;
      const target = document.getElementById(id);
      if (!target || !this.root.contains(target)) return false;
      if (this.search.value) { this.search.value = ''; this.applyFilter(''); }
      if (target.matches('[data-fs-faq-item]')) target.open = true;
      requestAnimationFrame(() => {
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        target.querySelector('summary')?.focus({ preventScroll: true });
      });
      return true;
    }

    prepareCopy(item) {
      const button = item.querySelector('[data-fs-faq-copy]');
      if (!button) return;
      button.hidden = false;
      const status = document.createElement('span');
      status.className = 'fs-help-copy-status';
      status.setAttribute('data-fs-copy-feedback', '');
      status.setAttribute('role', 'status');
      button.insertAdjacentElement('afterend', status);
    }

    copyLink(button) {
      const item = button.closest('[data-fs-faq-item]');
      if (!item?.id) return;
      const link = new URL(window.location.pathname, window.location.origin);
      const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) link.searchParams.set('preview_theme_id', preview);
      link.hash = item.id;
      const url = link.href;
      const status = item.querySelector('[data-fs-copy-feedback]');
      if (status) status.textContent = '';
      const fallback = () => {
        let input = item.querySelector('.fs-help-copy-fallback');
        if (!input) { input = document.createElement('input'); input.className = 'fs-help-copy-fallback'; input.type = 'url'; input.readOnly = true; input.setAttribute('aria-label', button.dataset.fsFaqCopyLabel); button.insertAdjacentElement('afterend', input); }
        input.value = url; input.hidden = false; input.focus(); input.select();
      };
      const success = () => {
        if (status) status.textContent = button.dataset.fsFaqCopyStatus;
        const input = item.querySelector('.fs-help-copy-fallback');
        if (input) input.hidden = true;
      };
      if (!navigator.clipboard?.writeText) { fallback(); return; }
      navigator.clipboard.writeText(url).then(success).catch(fallback);
    }

    updateStatus(count) { if (this.status) this.status.textContent = (this.status.dataset.template || '').replace('__COUNT__', count); }
  }

  const initHelpTopics = () => document.querySelectorAll('[data-fs-faq]').forEach((root) => { if (!root.__fsHelpTopics) { root.__fsHelpTopics = new FormulaSwissHelpTopics(root); root.__fsHelpTopics.init(); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHelpTopics, { once: true }); else initHelpTopics();
  document.addEventListener('shopify:section:load', initHelpTopics);
})();
